// Libs
import { createSelector } from 'reselect'

// Selectors
import selectedField$ from './selectedField'

// Utils
import traverse from 'fc-utils/traverse'
import emptyArrayOr from 'fc-utils/emptyArrayOr'

// Constants
import { PROP_SHAPE } from 'fc-model-assets'
import { PROP_SHAPE_DATA } from 'fc-model-shapes'

// Turf
import turfArea from '@turf/area'
import turfBbox from '@turf/bbox'

// Local Utils
const getGeoJSON = traverse([PROP_SHAPE, PROP_SHAPE_DATA])

// Exports
export default createSelector(
  [selectedField$],
  function (field) {
    const geoJSON = getGeoJSON(field)

    if (geoJSON) {
      try {
        const featureCollection = geoJSON
        return emptyArrayOr(featureCollection.features.map(function (feature: Object, index: number) {
          return {
            ...feature,
            bbox: turfBbox(feature),
            properties: {
              ...feature.properties,
              featureIndex: index,
              area: turfArea(feature),
            },
          }
        }))
      } finally {}
    }

    return emptyArrayOr()
  }
)
